import { makeStyles, createStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) =>
  createStyles({
    component: {
      marginTop: "1.8rem",
      width: "100%",
      height: "182px",
      backgroundColor: "#FFFFFF",
      borderRadius: "2px",
      display: "flex",
      justifyContent: "space-between",
    },
    align: {
      display: "flex",
      margin: "10px",
      marginTop: "20px",
      marginLeft: "20px",
    },
    parag: {
      color: "#808080",
      marginLeft: "20px",
      marginTop: "20px",
    },
    alignGrafico: {
      display: "flex",
    },
    circleBullet: {
      borderRadius: "30%",
    },
    legendList: {
      display: "grid",
      gridTemplateColumn: "1fr 1fr",
      listStyle: "none",
    },
    BulletLabel: {
      display: "flex",
      alignItems: "center",
    },
    BulletLabelText: {
      color: "#A1A0BD",
      fontWeight: "800",
      marginLeft: "10px",
    },
    BulletLabelValue: {
      color: "#16325C",
      fontWeight: "800",
      marginLeft: "5px",
    },
    BulletLabelUnit: {
      color: "#16325C",
      fontWeight: "800",
      marginLeft: "30px",
    },
    grafico: {
      display: "flex",
    },
    BulletLabelAlign: {
      display: "flex",
    },

  })
);

export default useStyles;